<template>
  <div class="coinOut">
    <div class="pass-con" title="">
      <van-form
          ref="form"
          label-align="center"
          @submit="transferCoin"
      >
        <div class="bg-10px"></div>
        <van-field
            v-model="mobilePhone"
            clearable
            type="number"
            label="对方账户"
            placeholder="请输入对方手机号码"
            :rules="[{required: true, message: '必填'}]"
        >
        </van-field>
        <div class="bg-10px"></div>
        <van-field
            v-model="amount"
            clearable
            type="number"
            maxLength="10"
            label="转移数量"
            placeholder="请输入转移数量"
            :rules="[
              {required: true, message: '必填'},
              { pattern: /^[1-9]+\d*$/, message: '请输入整数数量' }
            ]"
        >
        </van-field>
        <div class="bg-10px"></div>
        <van-field
            v-model="remarks"
            clearable
            label="备注"
            placeholder="转出"
        >
        </van-field>

        <div class="btn-con" style="padding: 20px 0 0 0;">
          <van-button round block type="info" native-type="submit">确认转移</van-button>
        </div>
      </van-form>

    </div>

     <ant-pay ref="antpay" :show="show" :paynum="paynum" @close="onPayClose" @onPay="onPay" />

  </div>
</template>

<script>
  import { getUserInfo } from '@/api/my'
  import { integralTransfer } from '@/api/wallet/integral'
  import AntPay from '@/components/antpay/antpay'
  export default {
    components: {
      AntPay: AntPay,
    },
    data () {
      return {
        mobilePhone: '', // 手机号
        productCode: 'AntCoin', //蚂蚁金币代码
        toUserOpenId: '', //转入用户id
        amount: '',//转移数量
        remarks: '',//备注
        userOpenId: this.session('userOpenId'),//转出用户id

        show: false, // 是否展示密码框

        paynum: '0', // 需支付的金额
      }
    },
    methods:{
      onClickLeft() {
        this.$router.go(-1)
      },
      transferCoin(){
        this.$refs['form'].validate().then(()=>{
          getUserInfo({
            "mobilePhone": this.mobilePhone
          }).then(res=>{
            if(res.code===200){
              this.toUserOpenId = res.data.openid;
              this.show = true;
            }else {
              this.$toast('对方账户不存在！')
            }
          });
        });
      },

      onPayClose(){
        this.show = false
      },

      onPay(data){
        // this.$refs.antpay.$close('余额不足！')
        // this.$refs.antpay.$success('执行成功！')
        console.log(data)

        integralTransfer({
          amount: this.amount,
          fromUserOpenId: this.userOpenId,
          payPassword: data.payPassword,
          productCode: this.productCode,
          remarks: this.remarks || '转出金币',
          toUserOpenId: this.toUserOpenId,
          fromWalletType: 0, // 转出钱包类型，0：个人钱包
          toWalletType: 0, // 转入钱包类型，0：个人钱包
        }).then(res=>{
          // this.show = false;
          if(res.code===200){
            this.$refs.antpay.$success(res.message);
            this.$router.replace({name: 'coin'})
          }else {
            this.$refs.antpay.$close(res.message);
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
.coinOut{
  height: 100%;
  background-color: #f4f4f4;
  .pass-con{
    font-size: .427rem;
    padding: 0 .5rem;
    .pass-input{
      background-color: white;
      border-bottom: .5rem solid #ededed;
    }
  }

}
</style>
